import styled from 'styled-components';
import { Flex } from 'src/components/Styled/flex.styled';

export const Wrapper = styled(Flex)`
  height: 100vh;
  width: 100vw;
`;

export const StyledStatus = styled.p`
  font-size: 2rem;
`;
